import React from 'react';
import { motion } from 'framer-motion';
import { Compass, FileText, Palette, CheckCircle2 } from 'lucide-react';
const steps = [{
  icon: Compass,
  title: '1) Dirección',
  description: 'defines nicho, avatar, problema y promesa sin complicarte.'
}, {
  icon: FileText,
  title: '2) Desarrollo',
  description: 'generas índice + capítulos por secciones con prompts guiados.'
}, {
  icon: Palette,
  title: '3) Diseño',
  description: 'aplicas checklist de edición + formato para dejarlo "vendible".'
}];
const deliverables = ['Acceso a EBOOK CREATOR (GPT en español)', 'Videos paso a paso (para ejecutar sin perderte)', 'Guía para: tema → nicho → avatar → problema → promesa', '40 ideas de títulos + subtítulos con enfoque comercial', 'Tabla de contenidos profesional (12 capítulos, adaptable)', 'Redacción por capítulos/secciones con estructura lógica', 'Sugerencias para consistencia de tono y claridad', 'Checklist final "listo para vender" (coherencia + CTA + valor percibido)'];
const results = ['pasar de "ideas sueltas" a un ebook con estructura y objetivo,', 'crear un producto digital simple para vender como entrada,', 'ahorrar tiempo sin sacrificar claridad,', 'usar IA como apoyo sin que el resultado suene genérico,', 'terminar con un ebook listo para maquetar en PDF y publicar.'];
export function ProductSection() {
  return <section className="w-full py-24 px-6 bg-[#050505]" data-id="element-97">
      <div className="max-w-5xl mx-auto space-y-32" data-id="element-98">
        {/* Method GPS 3D */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-12" data-id="element-99">
          <h2 className="text-3xl md:text-4xl font-bold text-[#f0f0f0] text-center" data-id="element-100">
            Método GPS 3D: Dirección → Desarrollo → Diseño
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-101">
            {steps.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#0a0f0d] border-t-4 border-[#00d4aa] p-8 rounded-xl shadow-lg" data-id="element-102">
                <div className="w-12 h-12 bg-[#00d4aa]/10 rounded-lg flex items-center justify-center mb-6" data-id="element-103">
                  <item.icon className="w-6 h-6 text-[#00d4aa]" data-id="element-104" />
                </div>
                <h3 className="text-xl font-bold text-white mb-4" data-id="element-105">
                  {item.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-106">
                  {item.description}
                </p>
              </motion.div>)}
          </div>
        </motion.div>

        {/* Deliverables */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-[#0a0f0d] border border-gray-800 p-8 md:p-12 rounded-2xl" data-id="element-107">
          <h3 className="text-2xl md:text-3xl font-bold text-[#f0f0f0] mb-8 text-center" data-id="element-108">
            Al entrar a EBOOK CREATOR obtienes:
          </h3>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="mb-10" data-id="element-109">
            <img src="https://i.postimg.cc/N0gnDyNs/Copia-de-Sin-titulo.png" alt="EBOOK CREATOR — Todo lo que incluye" className="w-full h-auto rounded-xl shadow-lg" data-id="element-110" />
          </motion.div>

          <ul className="space-y-4 mb-12" data-id="element-111">
            {deliverables.map((item, i) => <li key={i} className="flex items-start space-x-3 text-gray-300" data-id="element-112">
                <CheckCircle2 className="w-6 h-6 text-[#00d4aa] flex-shrink-0 mt-0.5" data-id="element-113" />
                <span className="text-lg" data-id="element-114">{item}</span>
              </li>)}
          </ul>

          <div className="text-center space-y-6" data-id="element-115">
            <div className="space-y-2" data-id="element-116">
              <p className="text-gray-500 text-lg line-through" data-id="element-117">
                Valor total: $66.990
              </p>
              <div className="text-5xl font-bold text-white" data-id="element-118">$18.990</div>
              <span className="inline-block bg-[#00d4aa]/10 text-[#00d4aa] text-sm font-semibold px-4 py-1.5 rounded-full" data-id="element-119">
                Precio de lanzamiento
              </span>
            </div>
            <a href="https://aprendeemprendearg.com/cart/52712282784111:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (window.fbq) {
              window.fbq('track', 'InitiateCheckout', {
                content_name: 'EBOOK CREATOR',
                content_category: 'GPT',
                value: 18990,
                currency: 'ARS'
              });
            }
          }} className="w-full block bg-[#00d4aa] hover:bg-[#00bfa0] text-black font-bold text-lg px-8 py-4 rounded-lg transition-all transform hover:scale-105 no-underline" data-id="element-120">
              Sí, quiero EBOOK CREATOR por $18.990
            </a>
          </div>
        </motion.div>

        {/* Results */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto" data-id="element-121">
          <h2 className="text-3xl font-bold text-[#f0f0f0] mb-8" data-id="element-122">
            Con EBOOK CREATOR podrás:
          </h2>
          <ul className="space-y-4 text-lg text-gray-400 leading-relaxed" data-id="element-123">
            {results.map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-124">
                <span className="w-2 h-2 mt-2.5 bg-[#00d4aa] rounded-full flex-shrink-0" data-id="element-125" />
                <span data-id="element-126">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}